class FlexWrapDetect {
	constructor(selector) {
		this.$monitor_elements = document.querySelectorAll(selector);

		this.init_events();
	}

	init_events() {
		let self = this;
		window.addEventListener('resize', () => {
			self.calculate_wrap();
		});

		// Run on conent load
		document.addEventListener('DOMContentLoaded', () => {
			self.calculate_wrap();
		});
	}

	calculate_wrap() {
		let self = this;
		this.$monitor_elements.forEach(($elements) => {
			// If this has <= 1 children, there's no chance of wrapping
			if ($elements.children.length <= 1) {
				self.toggle_class($elements, false);
				return; // Return out to next element in loop
			}

			let top_position = null;
			let has_wrapped = false;

			// Loop the children and see if their top positions are 
			// different. If so, "it's a wrap"!
			Array.from($elements.children).every($child => {
				// Skip if this is the "or"
				if ($child.classList.contains('or')) {
					return true;
				}

				let position = Math.round($child.getBoundingClientRect().top);

				// If top position is null, this is the first child, so skip to the next child
				if (top_position === null) {
					top_position = position;
					return true; // Next child
				}

				if (top_position !== position) {
					has_wrapped = true;
					return false; // Stop looping
				}
			});

			self.toggle_class($elements, has_wrapped);
		});
	}

	toggle_class($element, $is_toggled_on) {
		$element.classList.toggle('wrapped', $is_toggled_on);
	}
}

new FlexWrapDetect('.flex-wrap-detect');